import React from "react"
import { Toggle } from "material-ui"
import strings from "../../../localization/strings"
import TimeActionBar from "../../common/TimeActionBar/TimeActionBar"
import { EDayOfWeek, IDate, EScheduleListType } from "../../../models"
import AccountStore from "../../../stores/AccountStore"

interface IProps {
  type: EScheduleListType
  showAllChildHierarchyData: boolean
  handleChangeShowAllChildHierarchyData(value: boolean): void

  referenceDate: IDate
  startDayOfWeek: EDayOfWeek
  handleChangeWeek(startDate: string, endDate: string): void
  showResourcePlanner: boolean
  handleChangeShowResourcePlanner(value: boolean): void
  includePlanShifts: boolean
  handleChangeIncludePlanShifts(value: boolean): void
}

const SchedulesActionBar: React.SFC<IProps> = (props: IProps) => {
  const tabView = [EScheduleListType.JobSchedule, EScheduleListType.ClientSchedule].includes(props.type)
  return (
    <div style={{ padding: 5, width: "100%" }}>
      <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <div>
          {props.type !== EScheduleListType.Master &&
            <TimeActionBar
              referenceDate={props.referenceDate}
              handleChangeTimeRange={props.handleChangeWeek}
              startDayOfWeek={(props.startDayOfWeek === undefined || props.startDayOfWeek === null) ? EDayOfWeek.Monday : props.startDayOfWeek}
              timeBarViewType={"week"}
            />
          }
        </div>
        <div style={{ marginTop: 13, marginRight: 25 }}>
          {tabView ?
            <Toggle
              data-intercom-target={"menu-ScheduleTab-Toggle-IncludePlanShifts"}
              label={strings.Include_Plan_Shifts}
              style={{ width: 275, paddingRight: 35 }}
              labelStyle={{ fontSize: 15, fontWeight: 500 }}
              toggled={props.includePlanShifts}
              onToggle={(e, value) => props.handleChangeIncludePlanShifts(value)}
            /> :
            <Toggle
              data-intercom-target={"ScheduleActionBar-Toggle-ShowAllHierarchyData"}
              label={strings.Show_All_Child_Hierarchy_Data}
              style={{ width: 275, paddingRight: 35 }}
              labelStyle={{ fontSize: 15, fontWeight: 500 }}
              toggled={props.showAllChildHierarchyData}
              onToggle={(e, value) => props.handleChangeShowAllChildHierarchyData(value)}
            />
          }
          {AccountStore.getEnableResourcePlannerSchedule() &&
            (props.type === EScheduleListType.Posted ||
              (tabView && !props.includePlanShifts)
            ) &&
            <Toggle
              data-intercom-target={"ScheduleActionBar-Toggle-ShowResourcePlanner"}
              label={strings.Resource_Planner_View}
              style={{ width: 275, paddingRight: 35 }}
              labelStyle={{ fontSize: 15, fontWeight: 500 }}
              toggled={props.showResourcePlanner}
              onToggle={(e, value) => props.handleChangeShowResourcePlanner(value)}
            />
          }
        </div>
      </div>
    </div>
  )
}

export default SchedulesActionBar
